import { render, staticRenderFns } from "./ScanRedirectPage.vue?vue&type=template&id=4ff9c126"
import script from "./ScanRedirectPage.vue?vue&type=script&lang=js"
export * from "./ScanRedirectPage.vue?vue&type=script&lang=js"
import style0 from "./ScanRedirectPage.vue?vue&type=style&index=0&id=4ff9c126&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports